import Vue from 'vue';
import VueI18n from 'vue-i18n';
import fr from '../locales/fr/index.js';
import en from '../locales/en/index.js';

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'fr',
    messages: {
        fr,
        en,
    },
});

// Hot Reloading
if (module.hot) {
    module.hot.accept(['../locales/fr', '../locales/en'], () => {
        i18n.setLocaleMessage('en', en);
        i18n.setLocaleMessage('fr', fr);
    });
}

export default i18n;
